<template>
    <div>
        <Card>
            <Row :gutter="24">
                <Col span="3">
                    <Input v-model="params.name" @on-change="getInventoryInformation">
                        <span slot="prepend">申请人</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.department" @on-change="getInventoryInformation">
                        <span slot="prepend">部门</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.inventory_date" @on-change="getInventoryInformation">
                        <span slot="prepend">盘点周期</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.status" @on-change="getInventoryInformation">
                        <span slot="prepend">状态</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.sn" @on-change="getInventoryInformation">
                        <span slot="prepend">资产编码</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Button type="text" icon="md-refresh-circle" @click="getInventoryInformation"></Button>
                </Col>
            </Row>

        </Card>
        <Table highlight-row ref="currentRowTable" :columns="columns3" :data="assetList"></Table>
        <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>
    </div>
</template>
<script>
import { getInventoryInformation, deleteInventoryInformation, updateInventoryInformation } from '@/api/cmdb'
export default {
  data () {
    return {
      columns3: [
        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '盘点周期',
          key: 'inventory_date',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '提交日期',
          key: 'created_at',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '姓名',
          key: 'name',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '邮箱',
          key: 'mail',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '固资信息',
          key: 'sn_list_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', { }, [
              h('div', [
                h('Tag', {
                  props: {
                    type: 'border',
                    color: '#7232dd'
                  },
                  style: {
                    marginLeft: '5px',
                    display: params.row.sn ? 'inline-block' : 'none'
                  }
                }, params.row.sn),

                h('Tag', {
                  props: {
                    type: 'border',
                    color: 'blue'
                  },
                  style: {
                    marginLeft: '5px',
                    display: params.row.sn_type ? 'inline-block' : 'none'
                  }
                }, params.row.sn_type)
              ])
            ]
            )
          }
        },
        {
          title: '原来资产列表',
          key: 'original_assets',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '申请状态',
          key: 'status',
          minWidth: 100,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.status === '新增' ? '#7232dd' : params.row.status === '异常' ? 'red' : 'green'
                }
              }, params.row.status)
            ])
          }
        },
        {
          title: '操作备注',
          key: 'operate_remark',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '备注',
          key: 'remark',
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    const param = { ...params.row }
                    this.$Modal.confirm({
                      render: (h) => {
                        return h('Input', {
                          props: {
                            value: null,
                            autofocus: true,
                            placeholder: 'Please enter your operate remark...'
                          },
                          on: {
                            input: (val) => {
                              param.operate_remark = val
                              updateInventoryInformation(param).then(_ => {
                                this.getInventoryInformation()
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                style: {
                  display: this.$store.state.user.superuser ? 'inline-block' : 'none'
                },
                on: {
                  'on-ok': () => {
                    deleteInventoryInformation({ id: params.row.id }).then(_ => {
                      this.getInventoryInformation()
                    })
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      params: { page: 1, size: 10 },
      assetList: [],
      count: 0
    }
  },
  mounted () {
    this.getInventoryInformation()
  },
  methods: {
    getInventoryInformation () {
      getInventoryInformation(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
    },
    currentHandle (page) {
      this.params.page = page
      this.getInventoryInformation()
    },
    pageSizeHandle (size) {
      this.params.size = size
      this.getInventoryInformation()
    }
  }
}
</script>
